import AverageTimeChart from '@/components/AverageTimeChart';
import AvgTimeInDaysByOwner from '@/components/AvgTimeInDaysByOwner';
import ChartAvgTimeByTechStack from '@/components/ChartAvgTimeByTechStack';
import ChartFromReadyToHire from '@/components/ChartFromReadyToHire';
import NewByOwnerChart from '@/components/NewByOwnerChart';
import NewCandidatesTable from '@/components/NewCandidatesTable';
import OriginChart from '@/components/OriginChart';
import RejectedChart from '@/components/RejectedChart';
import TalentPoolChart from '@/components/TalentPoolChart';
import TopPageLinks, { TopPageLinksTypes } from '@/components/TopPageLinks';
import * as Styles from './HiringReports.styles';

type HiringReportsProps = {
  topPageLinks: TopPageLinksTypes;
};

const HiringReportsComponent = function ({ topPageLinks }: HiringReportsProps): JSX.Element {
  return (
    <>
      <Styles.PageHeader>
        <Styles.Title>Reports</Styles.Title>
        <TopPageLinks {...topPageLinks} />
      </Styles.PageHeader>

      <Styles.Grid>
        <Styles.SevenColumns>
          <NewCandidatesTable />
        </Styles.SevenColumns>

        <Styles.FourColumns>
          <OriginChart />
          <RejectedChart />
        </Styles.FourColumns>

        <Styles.FourColumns>
          <NewByOwnerChart />
        </Styles.FourColumns>

        <Styles.SevenColumns>
          <ChartFromReadyToHire />
          <TalentPoolChart />
        </Styles.SevenColumns>

        <Styles.SevenColumns>
          <ChartAvgTimeByTechStack />
        </Styles.SevenColumns>

        <Styles.FourColumns>
          <AverageTimeChart />
          <AvgTimeInDaysByOwner />
        </Styles.FourColumns>
      </Styles.Grid>
    </>
  );
};

export default HiringReportsComponent;
